/* CUBE STORE - pagina prodotto
   1) rende richiudibile la sezione "Specifiche tecniche" (app Tably);
   2) sposta il nome del colore dal titolo a una riga sotto, piccola e grigia. */
(function () {
  /* ---------- 1. specifiche tecniche richiudibili ---------- */
  /* L'elenco delle specifiche viene spostato dentro un pannello e al suo
     posto compare un'intestazione cliccabile, con lo stesso aspetto degli
     altri riquadri della colonna ("Metodi di pagamento", "Calcola la tua
     taglia"). Il titolo originale dell'app viene nascosto: la nostra
     intestazione lo sostituisce, riusandone il testo cosi' se l'app cambia
     lingua il riquadro la segue. */

  function build() {
    var rows = document.querySelector('.tably-spec-premium-rows');
    if (!rows || rows.dataset.cubeAccordion === '1') return;

    var list = rows.querySelector('.tably-spec-premium-rows__list');
    if (!list) return;

    rows.dataset.cubeAccordion = '1';

    var title = rows.querySelector('.tably-spec-premium-rows__title');
    var label = title && title.textContent.trim() ? title.textContent.trim() : 'Specifiche tecniche';
    if (title) title.style.display = 'none';

    var accordion = document.createElement('div');
    accordion.className = 'cube-specs-accordion';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cube-specs-trigger';
    button.setAttribute('aria-expanded', 'false');

    var text = document.createElement('span');
    text.textContent = label;

    var icon = document.createElement('span');
    icon.className = 'cube-specs-trigger__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '+';

    button.appendChild(text);
    button.appendChild(icon);

    var panel = document.createElement('div');
    panel.className = 'cube-specs-panel';
    panel.hidden = true;

    rows.insertBefore(accordion, list);
    accordion.appendChild(button);
    accordion.appendChild(panel);
    panel.appendChild(list);

    button.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
    });
  }

  /* ---------- 2. colore sotto il titolo ---------- */
  /* Il colore non e' un dato a parte: il metafield "custom.colore" e' vuoto
     sui prodotti, quindi si ricava dal titolo sfruttando la convenzione CUBE,
     dove il colore e' sempre l'ultima parola:
       - se contiene "n" fra due accenti (topasblue´n´white) e' senz'altro un
         colore;
       - altrimenti vale come colore solo se e' tutta minuscola, lunga almeno
         5 lettere e senza cifre (teamline, actionteam, carbon). I nomi dei
         modelli CUBE sono maiuscoli o contengono numeri, quindi restano.
     Se nessuna delle due condizioni e' vera il titolo resta intero.

     Perche' in JavaScript e non in Liquid: il titolo della pagina prodotto
     non passa dal blocco "product-title" del tema (quello disegna i titoli
     delle schede) ma da un blocco di testo generico, dove non si puo'
     mettere logica.

     La riga va inserita FUORI dal contenitore ".text-block" del titolo:
     dentro erediterebbe la tipografia del blocco (32px, peso 700, nera) e
     le regole del tema batterebbero la classe da sola.

     L'H1 viene cercato solo nella pagina prodotto e solo se non e' dentro una
     scheda, per non toccare i titoli del carosello in fondo. */

  function isProductPage() {
    var main = document.getElementById('MainContent');
    return !!main && main.dataset.template === 'product';
  }

  function splitColor(title) {
    var words = title.trim().split(/\s+/);
    if (words.length < 2) return null;

    var last = words[words.length - 1];

    if (last.indexOf('´n´') === -1) {
      if (last !== last.toLowerCase()) return null;
      if (last.length < 5) return null;
      if (/[0-9]/.test(last)) return null;
    }

    return { title: words.slice(0, -1).join(' '), color: last };
  }

  function colorLine() {
    if (!isProductPage()) return;

    var heads = document.querySelectorAll('h1');
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (h.dataset.cubeColor === '1') continue;
      if (h.closest('product-card, .resource-card, .card, .spf-product-card')) continue;

      var parts = splitColor(h.textContent);
      if (!parts) {
        h.dataset.cubeColor = '1';
        continue;
      }

      h.dataset.cubeColor = '1';
      h.textContent = parts.title;

      var line = document.createElement('p');
      line.className = 'cube-pdp-colore';
      line.textContent = parts.color;

      /* fuori dal blocco di testo, e fuori dall'eventuale link del titolo */
      var anchor = h.closest('.text-block') || h.closest('a') || h;
      var host = anchor.parentElement;
      if (host) host.insertBefore(line, anchor.nextSibling);
    }
  }

  /* ---------- avvio ---------- */

  var queued = false;
  function run() {
    queued = false;
    build();
    colorLine();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }

  function init() {
    run();
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
